module.exports = {
  ...require("./new"),
  ...require("./append"),
  ...require("./support"),
  ...require("./answer"),
  ...require("./fund"),
  ...require("./resolve"),
}
